export const content = {
  en: {
    nav: {
      about: "About",
      quality: "Quality",
      shop: "Shop",
      wholesale: "Wholesale",
      reseller: "Reseller",
      contact: "Contact",
    },
    hero: {
      kicker: "Bandeng Presto · Heritage of Indonesia",
      mainPrimary: "Crafted in Steam,",
      mainSecondary: "Loved Through Generations.",
      sub: "Premium milkfish, pressure-steamed soft to the bone, vacuum-sealed and ready to fry. Shipped across Java & Bali — exported across ASEAN.",
      scroll: "Scroll",
      cta: "Shop Now",
      cta2: "For Wholesale",
    },
    news: {
      label: "News Release",
      heading: "Updates from the kitchen",
      viewAll: "View All",
      items: [
        { date: "2026.04.12", category: "Promo", title: "Lebaran hampers now open — limited 200 boxes." },
        { date: "2026.03.28", category: "Retail", title: "Now available at Hero, Ranch Market, and Grand Lucky stores." },
        { date: "2026.02.10", category: "Award", title: "Awarded ‘Best Heritage Souvenir’ by Kuliner Nusantara 2026." },
        { date: "2026.01.05", category: "Export", title: "First container of vacuum-pack bandeng shipped to Singapore." },
      ],
    },
    about: {
      label: "About Us",
      headline: "Three generations,",
      headline2: "one perfect bandeng.",
      bodyA: "BANDENG PRIMAROSO has steamed milkfish since 1972 — softening every bone with patience, pressure, and a family recipe carried from grandmother to grandson. We source fresh tambak milkfish from Pati, season with twelve indigenous spices, and pressure-cook each piece for hours.",
      bodyB: "Today we serve households, hotels, and oleh-oleh boutiques across the archipelago, and ship export containers to ASEAN. Same kitchen. Same recipe. Same warm taste of home.",
      meta: [
        { k: "1972", v: "Established" },
        { k: "HACCP", v: "Certified" },
        { k: "12+", v: "Native Spices" },
        { k: "24h", v: "Slow Steamed" },
      ],
    },
    quality: {
      label: "Quality & Process",
      headline: "Properly processed,",
      headline2: "properly standardised.",
      body: "Every milkfish is hand-selected, gutted, brined, and pressure-steamed for up to 24 hours until even the smallest bone turns soft. We then vacuum-seal each piece in food-grade pouches, flash-chill, and quality-check before it leaves the kitchen.",
      steps: [
        { id: "01", title: "Sourcing", desc: "Fresh tambak milkfish from Pati, harvested at dawn and on ice within 2 hours." },
        { id: "02", title: "Slow Presto", desc: "24-hour pressure-steaming with 12 native spices — bones turn butter-soft, flesh stays moist." },
        { id: "03", title: "Vacuum Seal", desc: "Food-grade vacuum pouches, flash-chilled. Stays fresh up to 6 months refrigerated." },
        { id: "04", title: "Ready to Fry", desc: "Open, fry 3 minutes, serve. Crispy outside, tender inside — kitchen-ready at home or in restaurants." },
      ],
      badges: ["HACCP Certified", "Halal MUI", "BPOM Registered", "Vacuum Sealed", "Cold-Chain Shipping"],
    },
    shop: {
      label: "Shop Bandeng",
      heading: "Order direct,",
      heading2: "retail or wholesale.",
      sub: "All items are presto vacuum, ready to fry. Free shipping across Java & Bali for orders above Rp 250.000.",
      items: [
        { id: "small",   name: "Bandeng Presto — Small",   weight: "~200 g",  price: 15000,  desc: "Single milkfish, ideal for one serving.",                tag: null },
        { id: "medium",  name: "Bandeng Presto — Medium",  weight: "~300 g",  price: 18000,  desc: "Bigger single milkfish — great for family lunch.",       tag: null },
        { id: "pack3",   name: "Family Pack of 3",         weight: "~900 g",  price: 50000,  desc: "Three medium bandeng, vacuum-packed. Save Rp 4.000.",    tag: "Popular" },
        { id: "kilo",    name: "Bulk per Kilogram",        weight: "1 kg",    price: 110000, desc: "Loose-pack per kilo — perfect for restaurants & cafés.", tag: "Reseller" },
        { id: "box6kg",  name: "Catering Box · 6 Kg",      weight: "6 kg",    price: 550000, desc: "Big box for events, hotels, and large gatherings.",      tag: "Best Value" },
      ],
      addCart: "Add to Cart",
      buyNow: "Buy on WhatsApp",
      ready: "Vacuum · Ready to Fry",
      shippingNote: "We ship via JNE, J&T, SiCepat, and AnterAja with cold-chain options. Payment via QRIS, BCA, Mandiri, BNI, GoPay, OVO, ShopeePay.",
    },
    distribution: {
      label: "Distribution & Wholesale",
      headline: "From Pati to your table —",
      headline2: "across Java, Bali, and ASEAN.",
      tiers: [
        {
          id: "retail",
          title: "Retail · Java & Bali",
          desc: "Direct-to-customer shipping across Java and Bali. 2–3 days cold-chain, tracked. Order from our shop or via WhatsApp.",
          highlights: ["Min. order 1 pc", "2–3 day delivery", "Cold-chain packaging", "QRIS · Bank · E-wallet"],
        },
        {
          id: "b2b",
          title: "B2B · Restaurant & Reseller",
          desc: "Negotiable wholesale pricing for restaurants, hotels, caterers, and resellers. Flexible monthly volume, dedicated account manager.",
          highlights: ["Volume-based pricing", "Flexible monthly delivery", "PO + tax invoice", "Account manager"],
        },
        {
          id: "export",
          title: "Export · ASEAN",
          desc: "FOB / CIF shipping to Singapore, Malaysia, Brunei, and the Philippines. Minimum order 100 kg per shipment, vacuum-pack + carton.",
          highlights: ["MOQ 100 kg", "FOB / CIF terms", "Halal MUI & BPOM docs", "ASEAN cold-chain logistics"],
        },
      ],
      ctaLabel: "Inquire wholesale rates",
    },
    company: {
      label: "Company",
      headline: "Built around a kitchen,",
      headline2: "not a factory.",
      body: "BANDENG PRIMAROSO is family-owned and family-run. We believe taste cannot be rushed and trust cannot be outsourced. Visit our facility in Semarang or one of our partner outlets across Indonesia.",
      cards: [
        { id: "Overview", title: "Overview", subtitle: "Our story, vision, and team." },
        { id: "Access", title: "Location", subtitle: "Semarang HQ + nationwide outlets." },
        { id: "Group", title: "Partners", subtitle: "Retailers, hotels, distributors." },
      ],
    },
    recruit: {
      label: "Reseller Program",
      headline: "Become a Primaroso partner.",
      body: "We are looking for warm-hearted people — resellers, distributors, and retail partners — who want to share an Indonesian taste of home. No experience needed. We provide training, marketing kits, and dedicated account support.",
      cta: "Join Us",
    },
    contact: {
      label: "Contact",
      heading: "Let's talk taste.",
      sub: "Retail, wholesale, or export — we read every message.",
      name: "Your name",
      email: "Email",
      phone: "Phone / WhatsApp",
      message: "Message",
      submit: "Send Message",
      whatsapp: "Chat on WhatsApp",
      sent: "Thank you. We'll reply within 24 hours.",
    },
    footer: {
      tagline: "Crafted in Steam, Loved Through Generations.",
      rights: "All rights reserved.",
      address: "Jl. Pandanaran No. 88, Semarang, Central Java, Indonesia",
    },
  },
  id: {
    nav: {
      about: "Tentang",
      quality: "Kualitas",
      shop: "Belanja",
      wholesale: "Grosir",
      reseller: "Reseller",
      contact: "Kontak",
    },
    hero: {
      kicker: "Bandeng Presto · Warisan Nusantara",
      mainPrimary: "Lahir dari Uap,",
      mainSecondary: "Diwariskan Lintas Generasi.",
      sub: "Bandeng premium dipresto hingga duri pun lembut, divacuum, siap goreng. Kami kirim ke seluruh Jawa & Bali — ekspor ke ASEAN.",
      scroll: "Geser",
      cta: "Belanja Sekarang",
      cta2: "Untuk Grosir",
    },
    news: {
      label: "Berita & Promo",
      heading: "Kabar terbaru dari dapur",
      viewAll: "Lihat Semua",
      items: [
        { date: "2026.04.12", category: "Promo", title: "Hampers Lebaran kini dibuka — terbatas 200 box." },
        { date: "2026.03.28", category: "Retail", title: "Tersedia di Hero, Ranch Market, dan Grand Lucky." },
        { date: "2026.02.10", category: "Penghargaan", title: "‘Best Heritage Souvenir’ Kuliner Nusantara 2026." },
        { date: "2026.01.05", category: "Ekspor", title: "Kontainer pertama bandeng vacuum dikirim ke Singapura." },
      ],
    },
    about: {
      label: "Tentang Kami",
      headline: "Tiga generasi,",
      headline2: "satu bandeng sempurna.",
      bodyA: "BANDENG PRIMAROSO sudah menanak bandeng sejak 1972 — melunakkan setiap duri dengan kesabaran, tekanan, dan resep keluarga yang diwariskan dari nenek ke cucu. Bandeng segar kami datang dari tambak Pati, dibumbui dua belas rempah Nusantara, dan dipresto berjam-jam.",
      bodyB: "Kini kami melayani rumah tangga, hotel, dan toko oleh-oleh di seluruh nusantara, dan mengirim kontainer ekspor ke ASEAN. Dapur yang sama. Resep yang sama. Rasa rumah yang sama hangatnya.",
      meta: [
        { k: "1972", v: "Berdiri" },
        { k: "HACCP", v: "Tersertifikasi" },
        { k: "12+", v: "Rempah Asli" },
        { k: "24 jam", v: "Diproses Perlahan" },
      ],
    },
    quality: {
      label: "Kualitas & Proses",
      headline: "Diolah dengan baik,",
      headline2: "terstandar dengan baik.",
      body: "Setiap bandeng kami pilih, bersihkan, ungkep, dan presto hingga 24 jam sampai duri terkecil pun melunak. Setiap potong divacuum dengan pouch food-grade, di-flash chill, dan lolos quality check sebelum meninggalkan dapur.",
      steps: [
        { id: "01", title: "Pemilihan Bahan", desc: "Bandeng segar dari tambak Pati, dipanen subuh, masuk es dalam 2 jam." },
        { id: "02", title: "Presto Perlahan", desc: "Dipresto 24 jam dengan 12 rempah Nusantara — duri jadi lembut, daging tetap juicy." },
        { id: "03", title: "Vacuum Seal", desc: "Pouch vacuum food-grade, flash-chilled. Tahan hingga 6 bulan di kulkas." },
        { id: "04", title: "Siap Goreng", desc: "Tinggal buka, goreng 3 menit, sajikan. Crispy di luar, lembut di dalam — siap rumah maupun restoran." },
      ],
      badges: ["HACCP Tersertifikasi", "Halal MUI", "Terdaftar BPOM", "Vacuum Sealed", "Cold-Chain Shipping"],
    },
    shop: {
      label: "Belanja Bandeng",
      heading: "Pesan langsung,",
      heading2: "eceran maupun grosir.",
      sub: "Semua produk dipresto vacuum, siap goreng. Gratis ongkir Jawa & Bali untuk pesanan di atas Rp 250.000.",
      items: [
        { id: "small",   name: "Bandeng Presto — Satuan Kecil",  weight: "~200 g",  price: 15000,  desc: "Bandeng satuan, pas untuk satu porsi.",                  tag: null },
        { id: "medium",  name: "Bandeng Presto — Satuan Medium", weight: "~300 g",  price: 18000,  desc: "Ukuran medium, mantap untuk makan keluarga.",            tag: null },
        { id: "pack3",   name: "Pack Isi 3",                     weight: "~900 g",  price: 50000,  desc: "Tiga bandeng medium dalam satu vacuum. Hemat Rp 4.000.", tag: "Populer" },
        { id: "kilo",    name: "Per Kilogram",                   weight: "1 kg",    price: 110000, desc: "Kemasan kiloan — cocok untuk warung & restoran.",       tag: "Reseller" },
        { id: "box6kg",  name: "Box Family · 6 Kg",              weight: "6 kg",    price: 550000, desc: "Box besar untuk acara, hotel, dan kumpul keluarga.",    tag: "Paling Hemat" },
      ],
      addCart: "Tambah Keranjang",
      buyNow: "Beli via WhatsApp",
      ready: "Vacuum · Siap Goreng",
      shippingNote: "Pengiriman lewat JNE, J&T, SiCepat, AnterAja dengan opsi cold-chain. Pembayaran QRIS, BCA, Mandiri, BNI, GoPay, OVO, ShopeePay.",
    },
    distribution: {
      label: "Distribusi & Grosir",
      headline: "Dari Pati ke meja Anda —",
      headline2: "seantero Jawa, Bali, hingga ASEAN.",
      tiers: [
        {
          id: "retail",
          title: "Eceran · Jawa & Bali",
          desc: "Pengiriman langsung ke pelanggan se-Jawa dan Bali. 2–3 hari cold-chain, dapat dilacak. Pesan dari toko kami atau via WhatsApp.",
          highlights: ["Min. 1 pcs", "Pengiriman 2–3 hari", "Kemasan cold-chain", "QRIS · Bank · E-wallet"],
        },
        {
          id: "b2b",
          title: "B2B · Restoran & Reseller",
          desc: "Harga grosir bisa nego untuk restoran, hotel, katering, dan reseller. Volume bulanan fleksibel dan didampingi account manager.",
          highlights: ["Harga berbasis volume", "Pengiriman bulanan fleksibel", "PO + faktur pajak", "Account manager khusus"],
        },
        {
          id: "export",
          title: "Ekspor · ASEAN",
          desc: "Pengiriman FOB / CIF ke Singapura, Malaysia, Brunei, dan Filipina. Minimum order 100 kg per shipment, vacuum-pack + karton.",
          highlights: ["MOQ 100 kg", "FOB / CIF", "Dokumen Halal MUI & BPOM", "Logistik cold-chain ASEAN"],
        },
      ],
      ctaLabel: "Tanya harga grosir",
    },
    company: {
      label: "Perusahaan",
      headline: "Dibangun di sekitar dapur,",
      headline2: "bukan pabrik.",
      body: "BANDENG PRIMAROSO dimiliki dan dikelola keluarga. Kami percaya rasa tidak bisa dikejar, dan kepercayaan tidak bisa di-outsource. Kunjungi dapur kami di Semarang atau outlet mitra di seluruh Indonesia.",
      cards: [
        { id: "Overview", title: "Tentang", subtitle: "Cerita, visi, dan tim kami." },
        { id: "Access", title: "Lokasi", subtitle: "HQ Semarang + outlet nasional." },
        { id: "Group", title: "Mitra", subtitle: "Retail, hotel, distributor." },
      ],
    },
    recruit: {
      label: "Program Reseller",
      headline: "Jadilah mitra Primaroso.",
      body: "Kami mencari orang-orang berhati hangat — reseller, distributor, dan mitra retail — yang ingin berbagi rasa rumah khas Indonesia. Tanpa pengalaman pun bisa. Kami menyediakan pelatihan, kit pemasaran, dan dukungan akun khusus.",
      cta: "Bergabung",
    },
    contact: {
      label: "Kontak",
      heading: "Mari bicara rasa.",
      sub: "Eceran, grosir, atau ekspor — semua kami baca.",
      name: "Nama Anda",
      email: "Email",
      phone: "Telepon / WhatsApp",
      message: "Pesan",
      submit: "Kirim Pesan",
      whatsapp: "Chat lewat WhatsApp",
      sent: "Terima kasih. Kami balas dalam 24 jam.",
    },
    footer: {
      tagline: "Lahir dari Uap, Diwariskan Lintas Generasi.",
      rights: "Hak cipta dilindungi.",
      address: "Jl. Pandanaran No. 88, Semarang, Jawa Tengah, Indonesia",
    },
  },
};

export const formatRupiah = (n) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(n);
